import { LoginPayload } from '@/modules/Auth/types/payload'
import { GetUserInfoResponse } from '@/modules/Auth/types/response'
import { ResponseObject } from '@/types/shared'
import datacentral from '@/utils/axios/datacentral'

export const getUserInfo = async () => {
    const response =
        await datacentral.get<ResponseObject<GetUserInfoResponse>>('/auth/me')
    return response.data
}

export const checkRequireAction = async (payload: LoginPayload) => {
    const response = await datacentral.post('/auth/require', payload)
    return response.data
}

export const resetPassword = async (payload: LoginPayload) => {
    const response = await datacentral.post('/auth/reset-password', payload)
    return response.data
}
